import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button, Radio } from 'antd';
import moment from 'moment';
import auth from '../../../common/utility/auth';
import './styles.css';
import { message } from 'antd';
import BarcodeReader from "react-barcode-reader";
import { REF_TRA } from '../../../common/types/configuracionType';

import { FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';
import {
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    LOGISTICA_PRODUCTOS_CON_LOTE,
    SERIE_POR_PRODUCTO

} from '../../../common/types/parametroType';

import DetalleProductoServicioModal from './FormModal/DetalleProductoServicioModal';
import DetalleReferenciaModal from './FormModal/DetalleReferenciaModal';
import TotalDetalle from './FormModal/TotalModal';

const InputGroup = Input.Group;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            result: "No result",
        };
        this.handleScan = this.handleScan.bind(this);

    }

    handleScan(data) {
        this.props.onScanerProduct(
            data,
            this.props.form.setFieldsValue,
            this.props.form.getFieldValue,
            this.handleCalculateDetail
        );
    }

    handleError(err) {
        alert("error");
        console.error(err);
    }

    findDaysAndDates = (property, value) => {
        if (property === 'fechaStr') {
            console.log('cambio 2');
            const fecha = moment(value, 'DD/MM/YYYY');
            const minFecha = fecha.format('YYYY/MM/DD');

            const gridProductos = this.props.form.getFieldValue('arrDetalle');
            const detalleProductos = this.props.formValues.listaComprobanteDetalle;
            for (var i = 0; i < detalleProductos.length; i++) {
                var obj_current_data = gridProductos.filter(m => { return m.identifier === detalleProductos[i].identifier; })[0];

                detalleProductos[i].fechaVencimiento = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
                detalleProductos[i].flagAfecto = obj_current_data.flagAfecto;
                detalleProductos[i].precioUnitario = obj_current_data.precioUnitario;
                detalleProductos[i].cantidad = obj_current_data.cantidad;
                detalleProductos[i].subTotal = obj_current_data.subTotal;
                detalleProductos[i].igv = obj_current_data.igv;
                detalleProductos[i].total = obj_current_data.total;
                detalleProductos[i].numeroLote = obj_current_data.numeroLote;
                detalleProductos[i].minFechaStr = minFecha;
            }

            this.props.form.setFieldsValue({ listaComprobanteDetalle: detalleProductos });
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === '' || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: '0.000' });
        else
            this.props.form.setFieldsValue({ [property]: parseFloat(value).toFixed(3) });
    }


    fetchNewValue = (value, numberDecimals) => {
        if (numberDecimals === 2)
            return value === '' || isNaN(parseFloat(value).toFixed(2)) ? 0 : parseFloat(value);
        if (numberDecimals === 3)
            return value === '' || isNaN(parseFloat(value).toFixed(3)) ? 0 : parseFloat(value);
        if (numberDecimals === 5)
            return value === '' || isNaN(parseFloat(value).toFixed(5)) ? 0 : parseFloat(value);
        if (numberDecimals === 0)
            return value === '' || isNaN(parseFloat(value).toFixed(0)) ? 0 : parseFloat(value);

        return 0;
    };

    fetchFieldValue = (identifier, property) => {
        var result = parseFloat(this.props.form.getFieldValue(`${property}[${identifier}]`));
        return result;
    };

    fetchFieldValueSum = (identifier, property, paramValue) => {
        var suma = 0;
        var obj = Object.assign({}, this.props.form.getFieldValue(property));

        for (var [key, value] of Object.entries(obj)) {
            suma = suma + (key === identifier ? paramValue : parseFloat(value));
        }

        return suma;
    };
    documentoCustomValidation = (rule, value, callback) => {
        if (value === "00000000") callback("Documento no válido");

        callback();
    };

    completeDocumento = (e) => {
        var value = e.target.value;
        if (value.length === 0) return;

        var zeros = "";
        for (let index = 0; index < 8 - value.length; index++) {
            zeros += "0";
        }
        this.props.form.setFieldsValue({ documento: zeros + value }, () => {
            this.props.form.validateFields(["documento"], { force: true });
        });
    };

    handleCalculateDetail = (row, property, value, numberDecimals) => {

        var newValue = this.fetchNewValue(value, numberDecimals);
        var params = auth.user().parametros;
        var identifier = row.identifier;
        // Datos de parametro //
        const mostrarVencimiento = params.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
       
        /// Datos por fila //
        var idProducto = property === "arrIdProducto" ? value : this.props.form.getFieldValue(`arrIdProducto[${identifier}]`);
        var flagAfecto = property === "arrFlagAfecto" ? value : this.props.form.getFieldValue(`arrFlagAfecto[${identifier}]`);
        var cantidad = property === "arrCantidad" ? newValue : this.fetchFieldValue(identifier, "arrCantidad");
        var precioUnitario = property === "arrPrecioUnitario" ? newValue : this.fetchFieldValue(identifier, "arrPrecioUnitario");
        var total = property === "arrTotal" ? newValue : this.fetchFieldValue(identifier, "arrTotal");
        var fechaVencimiento = property === "arrFechaVencimiento" ? value : this.props.form.getFieldValue(`arrFechaVencimiento[${identifier}]`);
        var fechaProduccion = property === "arrFechaProduccion" ? value : this.props.form.getFieldValue(`arrFechaProduccion[${identifier}]`);
        var numeroLote = property === "arrLote" ? value : this.props.form.getFieldValue(`arrLote[${identifier}]`);
        var numeroRegistroSanitario = property === "arrNumeroRegistroSanitario" ? value : this.props.form.getFieldValue(`arrNumeroRegistroSanitario[${identifier}]`);
        /// Calculo totales //

        total = cantidad * precioUnitario;
        var dateVcto = row.flagVencimiento ? row.fechaVencimiento : null;

        /// Arr Detalle //
        var detalle = {
            identifier,
            precioUnitario,
            cantidad,
            flagAfecto,
            total,
            idProducto: row.idProducto,
            numeroRegistroSanitario: mostrarVencimiento ? numeroRegistroSanitario : null,
            numeroLote,
            fechaVencimiento: dateVcto,
            flagAplicarSerie: row.flagAplicarSerie,
            listaDetalleSerie: row.listaDetalleSerie,
            flagVencimiento: row.flagVencimiento,
            fechaProduccion: mostrarVencimiento ? fechaProduccion.format('DD/MM/YYYY') : null,
        };

        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== identifier });
        arrDetalleFilter.push(detalle);

        /// Calculo suma detalle //
        var sumaTotal = this.fetchFieldValueSum(identifier, "arrTotal", total);

        this.props.form.setFieldsValue({
            sumaTotal: sumaTotal,
            arrDetalle: arrDetalleFilter,
            [`arrLote[${identifier}]`]: numeroLote,
            [`arrNumeroRegistroSanitario[${identifier}]`]: numeroRegistroSanitario,
            [`arrFechaVencimiento[${identifier}]`]: fechaVencimiento,
            [`arrFechaProduccion[${identifier}]`]: fechaProduccion,
            [`arrPrecioUnitario[${identifier}]`]: precioUnitario.toFixed(5),
            [`arrCantidad[${identifier}]`]: cantidad.toFixed(2),
            [`arrTotal[${identifier}]`]: total.toFixed(2)
        });

        this.props.form.setFieldsValue({
            arrDetalle: arrDetalleFilter
        });
    };

    handleRemoverProducto = (row) => {
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== row.identifier });

        this.props.form.setFieldsValue({
            //    sumaTotalDetalle: sumaTotalDetalle,
            arrDetalle: arrDetalleFilter
        });

        this.props.onRemoverProducto(row.identifier);
    }


    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {

            if (!err) {
                var params = auth.user().parametros;
                var incluiIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;
                const mostrarVencimiento = params.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
                var flagReferencia = this.props.configuraciones.filter((m) => m.abreviatura === REF_TRA).length >= 1 ? true : false;

                var porcentajeIGV = 18;
                var sumTotal = (values.sumaTotal * 1.18).toFixed(0);
                var sumSubTotal = (values.sumaTotal).toFixed(2);
                var sumIgv = parseFloat(parseFloat(sumTotal) - parseFloat(sumSubTotal));

                const form = {
                    "id": values.id,
                    "idAlmacenOrigen": values.idAlmacen.key,
                    "idAlmacenDestino": values.idAlmacen2.key,
                    "idMoneda": values.idMoneda.key,
                    "fecha": null,
                    "fechaStr": values.fechaStr.format('DD/MM/YYYY'),
                    "idProyecto": values.idProyecto === undefined ? 0 : values.idProyecto.key,
                    "documento": null,
                    "serie": values.serie,
                    "idUsuarioRecepcion": values.idUsuarioRecepcion === undefined ? 0 : values.idUsuarioRecepcion.key,
                    "observacion": values.observacion,
                    "subTotal": parseFloat(sumSubTotal),
                    "igv": parseFloat(sumIgv),
                    "total": parseFloat(sumTotal),
                    "flag": true,
                    "tipoCambio": parseFloat(values.tipoCambio),
                    "porcentajeIGV": porcentajeIGV,
                    "idMovimientoIngreso": values.idMovimientoIngreso,
                    "idMovimientoSalida": values.idMovimientoSalida,
                    "transferenciaDetalles": [],
                    "transferenciaReferencias": []
                }

                if (values.arrDetalle.length <= 0) {
                    message.warning('Debe de ingresar como mínimo 1 producto.');
                    return;
                }
                if (values.sumaTotal === 0) {
                    message.warning('Por favor ingrese lo montos de forma correcta.');
                    return;
                }

                //Detalles----->
                var _fechaProd = null;
                var count_detalles = values.arrDetalle.length;
                for (var j = 0; j < count_detalles; j++) {
                    var det = values.arrDetalle[j];

                    if (mostrarVencimiento) {
                        _fechaProd = typeof (det.fechaProduccion) === "string" ? det.fechaProduccion : det.fechaProduccion.format('DD/MM/YYYY');
                    }

                    var valorUnitario = det.precioUnitario;
                    var precioUnitario = (det.precioUnitario * 1.18);

                    const itemDet = {
                        "id": 0,
                        "idTransferencia": 0,
                        "idProducto": parseInt(det.idProducto),
                        "nombre": det.nombre,
                        "flagAfecto": det.flagAfecto,
                        "flagVencimiento": det.flagVencimiento,
                        "cantidad": det.cantidad,
                        "listaTransferenciaDetalleSerie": det.listaDetalleSerie,
                        "valorUnitario": parseFloat(valorUnitario),
                        "precioUnitario": parseFloat(precioUnitario),
                        "subTotal": det.subTotal,
                        "igv": det.igv,
                        "total": parseFloat(precioUnitario) * det.cantidad,
                        "fechaVencimientoStr": det.fechaVencimiento,
                        "fechaProduccionStr": _fechaProd,
                        "numeroLote": det.numeroLote,
                        "numeroRegistroSanitario": mostrarVencimiento ? det.numeroRegistroSanitario : null,
                        "identifier": det.identifier
                    }
                    form.transferenciaDetalles.push(itemDet);
                }

                //Referencias-->
                if (values.idTipoComprobante !== undefined) {
                    var count_referencias = values.idTipoComprobante.length;// - 1;
                    for (var i = 0; i < count_referencias; i++) {
                        var tc = values.idTipoComprobante[i];
                        if (tc !== undefined) {

                            const itemRef = {
                                "id": 0,
                                "idMovimiento": 0,
                                "idReferenciaOrigen": 5,
                                "idReferencia": values.idOrdenCompra,
                                "idTipoComprobante": tc.key,
                                "serie": values.series[i],
                                "documento": values.documentos[i],
                                "flagInterno": false
                            }

                            form.transferenciaReferencias.push(itemRef);
                        }
                    }
                }
                if (flagReferencia && form.transferenciaReferencias.length == 0) {
                    message.error('Agregar la referencia');
                    return;
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.props.onChangeNameProduct(row);
    }

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('arrDetalle', { initialValue: this.props.formValues.listaComprobanteDetalle });

        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });

        return (
            <Modal
                title="Registro de Transferencia"
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="1200px"
            >
                <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}
                    {getFieldDecorator('idMovimientoIngreso', { initialValue: this.props.formValues.idMovimientoIngreso })(
                        <input type="hidden" />
                    )}
                    {getFieldDecorator('idMovimientoSalida', { initialValue: this.props.formValues.idMovimientoSalida })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                disabled={true}
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => {
                                                    this.props.onChange('fechaStr', value);
                                                    this.findDaysAndDates('fechaStr', value);
                                                }}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Requerido",
                                                    whitespace: true,
                                                }
                                            ],
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                style={{ textTransform: "uppercase" }}
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("documento", {
                                            initialValue: this.props.formValues.documento,
                                            rules: [
                                                {
                                                    validator: this.documentoCustomValidation,
                                                },
                                            ],
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                                onBlur={this.completeDocumento}
                                                maxLength={"8"}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idMoneda', option.key, this.props.form)}
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>



                    <div className="row">

                        <div className="col-md-3 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.idEstablecimiento ?
                                        { key: this.props.formValues.idEstablecimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.onChange("idEstablecimiento", option.key, this.props.form)
                                        }}
                                    >
                                        {this.props.formValues.establecimientos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-6 form-group">
                            <Form.Item label="Almacén Origen">
                                {getFieldDecorator('idAlmacen', {
                                    initialValue: this.props.formValues.idAlmacen ?
                                        { key: this.props.formValues.idAlmacen } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        loading={this.props.formValues.almacenLoading}
                                        onChange={(option) => {
                                            this.props.onChange("idAlmacen", option.key, this.props.form)
                                        }}
                                    >
                                        {this.props.formValues.almacenes.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Número Vale Origen">
                                {getFieldDecorator('numeroValeOrigen', {
                                    initialValue: this.props.formValues.numeroValeOrigen
                                })(
                                    <Input
                                        autoComplete="off"
                                        disabled={true}
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>


                    <div className="row">

                        <div className="col-md-3 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento2', {
                                    initialValue: this.props.formValues.idEstablecimiento2 ?
                                        { key: this.props.formValues.idEstablecimiento2 } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idAlmacen2: undefined });
                                            this.props.onChange("idEstablecimiento2", option.key)
                                        }}
                                    >
                                        {this.props.formValues.establecimientos2.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-6 form-group">
                            <Form.Item label="Almacén Destino">
                                {getFieldDecorator('idAlmacen2', {
                                    initialValue: this.props.formValues.idAlmacen2 ?
                                        { key: this.props.formValues.idAlmacen2 } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        loading={this.props.formValues.almacen2Loading}
                                    >
                                        {this.props.formValues.almacenes2.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Número Vale Destino">
                                {getFieldDecorator('numeroValeDestino', {
                                    initialValue: this.props.formValues.numeroValeDestino
                                })(
                                    <Input
                                        autoComplete="off"
                                        disabled={true}
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-md-3 form-group">
                            <Form.Item label="Encargado Recepción">
                                {getFieldDecorator('idUsuarioRecepcion', {
                                    initialValue: this.props.formValues.idUsuarioRecepcion ?
                                        { key: this.props.formValues.idUsuarioRecepcion } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Recepcion"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idUsuarioRecepcion', option.key, this.props.form)}
                                    >

                                        {this.props.formValues.empleados.map(item => (

                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>

                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('idProyecto', {
                                    initialValue: this.props.formValues.idProyecto ?
                                        { key: this.props.formValues.idProyecto } : 0
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idProyecto', option.key, this.props.form)}
                                    >
                                        <Option key={0} value={0}>
                                            <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                        </Option>
                                        {this.props.formValues.proyectos.map(item => (
                                            item.estado ?
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>


                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>


                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                tabBarExtraContent={
                                    <Button
                                        icon="plus"
                                        type="primary"
                                        onClick={() => this.props.onAgregarDetalle(this.props.form.setFieldsValue, this.props.form.getFieldValue)}
                                    >
                                        Agregar
                                    </Button>
                                }
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                     {seriePorProducto == 1 ?
                                            <div className="col-md-12 form-group" style={{marginLeft:-20}}>
                                                <div className="col-md-12 form-group">
                                                    <Form.Item>
                                                        {getFieldDecorator('flagTipoBusquedaScanner', {
                                                            initialValue: this.props.formValues.flagTipoBusquedaScanner
                                                        })(
                                                            <Radio.Group name="radiogroup"
                                                                // onChange={(e) => this.props.onChangeForm("flagTipoBusquedaScanner", e.target.value, this.props.form)}
                                                            >
                                                                <Radio value={0}>Búsqueda por código de barra</Radio>
                                                                <Radio value={1}>Búsqueda por serie</Radio>
                                                            </Radio.Group>
                                                        )}
                                                    </Form.Item>
                                                </div>
                                            </div> : null
                                        }
                                    <DetalleProductoServicioModal
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        onAgregarSerie={this.props.onAgregarSerie}
                                        onRemove={this.handleRemoverProducto}
                                        onCalculateDetail={this.handleCalculateDetail}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                        onChangeNameProduct={this.handleChangeNameProduct}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <DetalleReferenciaModal
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        tiposComprobante={this.props.formValues.tiposComprobante}
                                        onRemove={this.props.onRemoverReferencia}
                                        onGetFieldDecorator={getFieldDecorator}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <TotalDetalle
                        formValues={this.props.formValues}
                        onGetFieldDecorator={getFieldDecorator}
                        onGetFieldValue={getFieldValue}
                    />

                </Form>
            </Modal>
        )
    }
}
export default Form.create()(FormModal)